import React, {Component} from 'react';
import {Provider} from 'react-redux';
import styled from 'styled-components'
import Routing from './routing';
import '@firebase/firestore';
import {withAuthentication} from './components/Session';
import './App.css';
import {ModalProvider, BaseModalBackground } from "styled-react-modal";
import store from './store/store';
import Geolocation from './Services/Geolocation';


const FadingBackground = styled(BaseModalBackground)`
  opacity: ${props => props.opacity};
  transition: opacity ease 200ms;
`;


class App extends Component {
	constructor() {
		super();
		this.locationService = new Geolocation();
	}

	render() {
		return (
			<Provider store={store}>
				<ModalProvider backgroundComponent={FadingBackground}>

				{/*<HeaderContainer/>*/}
				<Routing {...this.props} />
				</ModalProvider>
			</Provider>
		);
	}
}

export default withAuthentication(App);
